import React, { useState } from "react";
import "./Support.css";
import Privacy from "./Privacy";

function Support() {
  const [page, setPage] = useState("support"); // Track which page to render

  // Function to open an email client with the correct subject
  const openEmail = (supportType) => {
    const recipientEmail = "albie@itiniri.com";
    const subject = encodeURIComponent(
      supportType === "Event Support"
        ? "Event support request"
        : supportType === "User Support"
        ? "User support request"
        : "Vendor support request"
    );

    window.location.href = `mailto:${recipientEmail}?subject=${subject}`;
  };

  const renderPage = () => {
    switch (page) {
      case "support":
        return (
          <div>
            <header className="support-header">
              <h1 className="support-title">Support</h1>
              <p className="support-description">
                Click a support option below to send an email.
              </p>
            </header>
            <div className="support-forms">
              <button className="support-button" onClick={() => openEmail("Event Support")}>
                Event support
              </button>
              <button className="support-button" onClick={() => openEmail("User Support")}>
                User support
              </button>
              <button className="support-button" onClick={() => openEmail("Vendor Support")}>
                Vendor support
              </button>
            </div>
          </div>
        );
      case "privacy":
        return <Privacy />;
      default:
        return <h1>Page not found</h1>;
    }
  };

  return <div className="support-page">{renderPage()}</div>;
}

export default Support;
